module.exports = __webpack_public_path__ + "img/XLM-alt.b4445b8e.svg";